import React from "react";
import {
  Modal,
  Box,
  TextField,
  MenuItem,
  IconButton,
  CircularProgress,
  Button
} from "@material-ui/core";

const modalWrapperStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  maxHeight: "90vh",
  backgroundColor: "white",
  borderRadius: 12,
  boxShadow: 24,
  overflowY: "auto",
  display: "flex",
  flexDirection: "column"
};

const headerStyle = {
  backgroundColor: "#75287C",
  color: "white",
  padding: "0px 24px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderTopLeftRadius: 12,
  borderTopRightRadius: 12,
  minHeight: 56
};

const contentStyle = {
  padding: 24,
  flex: 1,
  overflowY: "auto"
};

const actionsStyle = {
  padding: "16px 24px",
  display: "flex",
  justifyContent: "flex-end",
  gap: 12,
  borderTop: "1px solid #eee"
};

const FormModalDigitalEnablementSession = ({
  open,
  onClose,
  isPersonaLoading,
  formData,
  handleInputChange,
  uniqueDigitalEnablementInstanceId,
  digitalEnablementInstances,
  isEdit,
  handleUpdateButtonClick,
  handleSubmitPersonaDetails,
  handleSubmitDigitalPersonaDetails,
  digitalEnablementAlreadyFilledPersonaInstanceId
}) => {

  // const handleSubmit = (data) => {
  //   if (data?.sResourceDisplayName === "Website Design & Development") {
  //     let params = {
  //       'Type': 'Digital_Enablement',
  //       'subType': "Digital Enablement",
  //       'nResourceInstanceId': data['nResourceInstanceId'],
  //       fields: {
  //         'Website Delivered Date': data['Website Delivered Date'],
  //         'Website Link': data['Website Link'],
  //       }
  //     }
  //         handleSubmitPersonaDetails(params);

  //   } else if (data?.sResourceDisplayName === "Mera Bills") {
  //     let params = {
  //       'Type': 'Digital_Enablement',
  //       'subType': "Digital Enablement",
  //       'nResourceInstanceId': data['nResourceInstanceId'],
  //       fields: {
  //         'Training Date': data['Training Date'],
  //         'Learning on Usage': data['Learning on Usage'],
  //       }
  //     }
  //         handleSubmitPersonaDetails(params);
  //   } else if (data?.sResourceDisplayName === "Social Media Management") {
  //     let params = {
  //       'Type': 'Digital_Enablement',
  //       'subType': "Digital Enablement",
  //       'nResourceInstanceId': data['nResourceInstanceId'],
  //       fields: {
  //         'Service Delivery Date': data['Service Delivery Date'],
  //         'Experience & Effect': data['Experience & Effect'],
  //       }
  //     }
  //         handleSubmitPersonaDetails(params);
  //   }
  //   else if (data?.sResourceDisplayName === "Online Starter Pack") {
  //     let params = {
  //       'Type': 'Digital_Enablement',
  //       'subType': "Digital Enablement",
  //       'nResourceInstanceId': data['nResourceInstanceId'],
  //       fields: {
  //         'Video Delivered Date': data['Video Delivered Date'],
  //         'Usage Clarity & Experience': data['Usage Clarity & Experience'],
  //         'Link to Brand Video': data['Link to Brand Video']
  //       }
  //     }
  //         handleSubmitPersonaDetails(params);
  //   }

  // }
  const handleSubmit = (data) => {

  let fields = {};

  if (data?.sResourceDisplayName === "Website Design & Development") {
    fields = {
      "ResourceDisplayName": data['sResourceDisplayName'],
      "ResourceDisplayType": data['sResourceDisplayName'],
      "Website Delivered Date": data['dtCreated'],
      "Website Link": data["Website Link"],
    };
  }

  else if (data?.sResourceDisplayName === "Mera Bills") {
    fields = {
      "ResourceDisplayName": data['sResourceDisplayName'],
      "ResourceDisplayType": data['sResourceDisplayName'],
      "Training Date": data['dtDelivered'],
      "Learning on Usage": data["Learning on Usage"],
    };
  }

  else if (data?.sResourceDisplayName === "Social Media Management") {
    fields = {
      "ResourceDisplayName": data['sResourceDisplayName'],
      "ResourceDisplayType": data['sResourceDisplayName'],
      "Service Delivery Date": data["dtDelivered"],
      "Experience & Effect": data["Experience & Effect"],
    };
  }

  else if (data?.sResourceDisplayName === "Online Starter Pack") {
    fields = {
      "ResourceDisplayName": data['sResourceDisplayName'],
      "ResourceDisplayType": data['sResourceDisplayName'],
      "Service Delivery Date": data["dtDelivered"],
      "Experience & Effect": data["Experience & Effect"],
    };
  }
  else if (data?.sResourceDisplayName === "Brand Video") {
    fields = {
      "ResourceDisplayName": data['sResourceDisplayName'],
      "ResourceDisplayType": data['sResourceDisplayName'],
      "Video Delivered Date": data["dtDelivered"],
      "Usage Clarity & Experience": data["Usage Clarity & Experience"],
      "Link to Brand Video": data["Link to Brand Video"],
    };
  }

  const params = {
    Type: "Digital_Enablement",
    subType: "Digital Enablement",
    fields,
    
  };

  handleSubmitDigitalPersonaDetails(params,data?.nResourceInstanceId);
  onClose();
};
  return (
    <Modal open={open} onClose={onClose}>
      <Box style={modalWrapperStyle}>

        {/* HEADER */}
        <Box style={headerStyle}>
          <div>Digital Enablement Persona Form</div>
          <IconButton onClick={onClose} style={{ color: "white" }}>
            X
          </IconButton>
        </Box>

        {/* FORM CONTENT */}
        <Box style={contentStyle} className={`${isPersonaLoading ? "set-opacity" : ""}`}>

          {isPersonaLoading && (
            <div className="center-screen">
              <CircularProgress />
            </div>
          )}

          {/* RESOURCE ID */}
          <TextField
            select
            name="nResourceInstanceId"
            label="Resource Instance Id"
            value={formData["nResourceInstanceId"]}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            disabled
          >
            {uniqueDigitalEnablementInstanceId && uniqueDigitalEnablementInstanceId?.map((option) => (
              <MenuItem
                key={option}
                value={option}
                disabled={digitalEnablementAlreadyFilledPersonaInstanceId?.includes(option)}
              >
                {option}
              </MenuItem>
            ))}
          </TextField>

          {/* SERVICE TYPE */}
          <TextField
            select
            name="nResourceInstanceId"
            label="Resource Display Name"
            value={formData.nResourceInstanceId}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            disabled
          >
            {digitalEnablementInstances.map((item) => (
              <MenuItem
                key={item.nResourceInstanceId}
                value={item.nResourceInstanceId}
              >
                {item.sResourceDisplayName}
              </MenuItem>
            ))}
          </TextField>
          {console.log('formData.serviceType', formData)}
          {/* TRAINING */}
          {(formData.serviceType || formData?.sResourceDisplayName) === "Mera Bills" && (
            <>
              <TextField
                type="date"
                name="Training Date"
                label="Training Date"
                value={formData?.dtCreated?.split("T")[0] || ""}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
                InputLabelProps={{ shrink: true }}
                disabled
              />

              <TextField
                name="Learning on Usage"
                label="Learning on Usage"
                value={formData["Learning on Usage"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
              />
            </>
          )}

          {/* WEBSITE */}
          {(formData.serviceType || formData?.sResourceDisplayName) === "Website Design & Development" && (
            <>
              <TextField
                type="date"
                name="Website Delivered Date"
                label="Website Delivered Date"
                value={formData?.dtDelivered?.split("T")[0] || ""}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
                InputLabelProps={{ shrink: true }}
                disabled
              />

              <TextField
                name="Website Link"
                label="Website Link"
                value={formData["Website Link"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
              />
            </>
          )}

          {/* SOCIAL MEDIA */}
          {/* {(formData.serviceType || formData?.sResourceDisplayName) === "Social Media Management" && (
            <>
              <TextField
                type="date"
                name="Service Delivery Date"
                label="Service Delivery Date"
                value={formData?.dtDelivered?.split("T")[0] || ""}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
                InputLabelProps={{ shrink: true }}
                disabled
              />

              <TextField
                name="Experience & Effect"
                label="Experience & Effect"
                value={formData["Experience & Effect"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
              />
            </>
          )} */}
          {/* SOCIAL MEDIA + ONLINE STARTER PACK */}
          {(
            (formData.serviceType || formData?.sResourceDisplayName) === "Social Media Management" ||
            (formData.serviceType || formData?.sResourceDisplayName) === "Online Starter Pack"
          ) && (
              <>
                <TextField
                  type="date"
                  name="Service Delivery Date"
                  label="Service Delivery Date"
                  value={formData?.dtDelivered?.split("T")[0] || ""}
                  onChange={handleInputChange}
                  fullWidth
                  margin="normal"
                  InputLabelProps={{ shrink: true }}
                  disabled
                />

                <TextField
                  name="Experience & Effect"
                  label="Experience & Effect"
                  value={formData["Experience & Effect"]}
                  onChange={handleInputChange}
                  fullWidth
                  margin="normal"
                />
              </>
            )}
{/* Online Starter Pack */}
          {/* BRAND VIDEO */}
          {(formData.serviceType || formData?.sResourceDisplayName) === "Brand Video" && (
            <>
              <TextField
                type="date"
                name="Video Delivered Date"
                label="Video Delivered Date"
                value={new Date(formData?.dtDelivered)}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
                InputLabelProps={{ shrink: true }}
                disabled
              />

              <TextField
                name="Usage Clarity & Experience"
                label="Usage Clarity & Experience"
                value={formData["Usage Clarity & Experience"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
              />

              <TextField
                name="Link to Brand Video"
                label="Link to Brand Video"
                value={formData["Link to Brand Video"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
              />
            </>
          )}

        </Box>

        {/* ACTION BUTTONS */}
        <Box style={actionsStyle}>

          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>

          {isEdit ? (
            <Button
              variant="contained"
              style={{ backgroundColor: "#75287C", color: "white" }}
              onClick={() => handleSubmit(formData)}
            >
              Update
            </Button>
          ) : (
            <Button
              variant="contained"
              style={{ backgroundColor: "#75287C", color: "white" }}
              onClick={() => handleSubmit(formData)}
            >
              Submit
            </Button>
          )}

        </Box>

      </Box>
    </Modal>
  );
};

export default FormModalDigitalEnablementSession;